import { render, staticRenderFns } from "./SummeryPage.vue?vue&type=template&id=5dbf1943&"
import script from "./SummeryPage.vue?vue&type=script&lang=js&"
export * from "./SummeryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports